import { createFileRoute } from '@tanstack/react-router';

import { AppliedRoute } from '@mint-emails/recommendation/routes';

export const Route = createFileRoute('/recommendation/applied')({
  component: RouteComponent,
});

function RouteComponent() {
  return <AppliedRoute />;
}
